// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__gR92L"};